module.exports = __webpack_public_path__ + "static/media/icon-phone.34d3c590.svg";